import { NgModule } from '@angular/core';
import { SpLayoutDashboardDefaultModule } from './sp-layout-dashboard-default/sp-layout-dashboard-default.module';
import { SpLayoutDashboardDeskModule } from './sp-layout-dashboard-desk/sp-layout-dashboard-desk.module';
import { SpLayoutDashboardSimpleModule } from './sp-layout-dashboard-simple/sp-layout-dashboard-simple.module';

@NgModule({
  exports: [
    SpLayoutDashboardDefaultModule,
    SpLayoutDashboardDeskModule,
    SpLayoutDashboardSimpleModule
  ],
  imports: [
    SpLayoutDashboardDefaultModule,
    SpLayoutDashboardDeskModule,
    SpLayoutDashboardSimpleModule
  ]
})
export class SpLayoutModule {}
